<script>
    import TheSvgIcon from "@main/packages/TheSvgIcon";
    import CenterNavigationMenu from "@/components/CenterNavigationMenu";
    import TopNavigationMenu from "@/components/TopNavigationMenu";
    import LinkWithAnalytics from "@/components/LinkWithAnalytics";
    import SelectCity from "@/components/SelectCity";
    import HeaderStatusOrder from "@/components/header/HeaderStatusOrder";
    import TheContactsEmails from "@miku-kz/components/TheContactsEmails";

    export default {
        name: "TheHeaderMobileMenu",
        components: {
            TheContactsEmails,
            HeaderStatusOrder,
            SelectCity,
            TheSvgIcon,
            LinkWithAnalytics,
            TopNavigationMenu,
            CenterNavigationMenu,
        },
        props: {
            topMenu: Array,
            centerMenu: Array,
            city: String,
            phoneCallCenter: String,
        },
        methods: {
            onClick(hash) {
                this.$emit("on-click", hash);
            },
        },
    };
</script>

<template>
    <div class="the-header-mobile-menu">
        <div class="the-header-mobile-menu__top">
            <div class="the-header-mobile-menu__navigation">
                <center-navigation-menu
                    :menu="centerMenu"
                    @on-click="onClick"
                ></center-navigation-menu>
            </div>

            <top-navigation-menu
                :menu="topMenu"
                :city="city"
                @on-click="onClick"
            ></top-navigation-menu>
        </div>
        <div class="the-header-mobile-menu__bottom">
            <div class="the-header-mobile-menu__city">
                <select-city :city="city"></select-city>
            </div>

            <div class="the-header-mobile-menu__order">
                <header-status-order></header-status-order>
            </div>

            <link-with-analytics
                class="the-header-mobile-menu__phone"
                type="phone"
                :text="phoneCallCenter"
            ></link-with-analytics>

            <button
                class="the-header-mobile-menu__callback"
                @click="$popup.show('modal-callback')"
            >
                <the-svg-icon name="callback" :size-w="20" is-common></the-svg-icon>
                Перезвоните мне
            </button>

            <div class="the-header-mobile-menu__emails">
                <the-contacts-emails></the-contacts-emails>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .the-header-mobile-menu {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .the-header-mobile-menu__top {
        padding: 20px;
        background-color: #fff;
    }

    .the-header-mobile-menu__bottom {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 20px 60px;
        background-color: #000;
    }

    .the-header-mobile-menu__navigation {
        margin-bottom: 18px;
    }

    .the-header-mobile-menu__city {
        margin-bottom: 8px;
    }

    .the-header-mobile-menu__order {
        margin-bottom: 40px;
    }

    .the-header-mobile-menu__phone {
        display: block;
        margin-bottom: 20px;
        color: #fff;
        font-size: 30px;
        font-weight: 700;
        line-height: 42px;
    }

    .the-header-mobile-menu__callback {
        display: flex;
        align-items: center;
        margin-bottom: 60px;
        padding: 10px 23px;
        color: #fff;
        font-size: 18px;
        font-weight: 600;
        line-height: 22px;
        text-align: center;
        background-color: var(--danger);
        border-radius: 6px;
        svg {
            margin-right: 5px;
        }
    }
</style>
